import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { connectMenu, Highlight } from 'react-instantsearch-dom'
import { text } from 'chaoskit/src/assets/styles/utility'

import TeaserCard from '~components/case-studies/TeaserCard'

const CategoryMenu = ({ items, refine, createURL }) => {
  const theme = useTheme()

  return items.length > 0 ? (
    <nav
      css={{
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 'auto',
        gap: 2,
        background: theme.color.border.base,
        textAlign: 'center',
      }}
    >
      {items.map((item) => (
        <a
          key={item.value}
          href={createURL(item.value)}
          onClick={(event) => {
            event.preventDefault()
            refine(item.value)
          }}
          css={[
            {
              background: theme.color.light.base,
              ...text.expanded(theme),
              color: theme.fontColor.base,
              ...theme.text.small,
              paddingTop: theme.space.small,
              paddingBottom: theme.space.small,
              paddingLeft: theme.space.small + theme.space.xsmall,
              paddingRight: theme.space.small + theme.space.xsmall,
              position: 'relative',
              fontWeight: theme.fontWeight.bold,

              '&:hover, &:focus': {
                color: theme.color.primary.base,
              },
            },
            item.isRefined && {
              color: theme.color.primary.base,

              '&::before': {
                content: "''",
                height: 2,
                display: 'block',
                left: theme.space.small + theme.space.xsmall,
                right: theme.space.small + theme.space.xsmall,
                background: theme.color.primary.base,
                position: 'absolute',
                bottom: 0,
              },
            },
          ]}
        >
          {item.label}
        </a>
      ))}
    </nav>
  ) : (
    <p css={{ ...theme.text.small, color: theme.fontColor.muted }}>
      No matching categories
    </p>
  )
}

CategoryMenu.propTypes = {
  items: PropTypes.array,
  refine: PropTypes.func,
  createURL: PropTypes.func,
}

export const CustomCategoryMenu = connectMenu(CategoryMenu)

export const Hit = ({ hit }) => (
  <TeaserCard
    data={hit}
    title={<Highlight tagName="mark" attribute="title" hit={hit} />}
  />
)

Hit.propTypes = {
  hit: PropTypes.object,
}
